<template>
  <div
    class="draggable resizable"
    style="position: absolute; top: 300px; left: 650px;"
  >
    <div
      @click="$emit('toFront')"
      class="mx-auto window win-card"
      style="width: 450px; background-color: #c0c0c0;"
      v-if="open"
    >
      <WindowBar
        title="A brief history of Oliver"
        @close="$emit('close')"
        @maximize="maximized=true"
        @minimize="maximized=false"
      />
      <Timeline v-show="maximized" />
    </div>
  </div>
</template>

<script>
import WindowBar from "./WindowBar.vue";
import Timeline from "./Timeline.vue";

export default {
  name: "AboutNE",
  data() {
    return {
      open: true,
      maximized: true
    };
  },
  components: {
    WindowBar,
    Timeline
  }
};
</script>

<style scoped src="98.css">
.window {
  touch-action: none;
}
</style>
